import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

export interface Props {
  className?: string
}

const BlockValue = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  return <div className={classNames('block-value-component', className)}>{children}</div>
}

export default BlockValue
